import React from 'react';

import btu_logo from '@/assets/images/logo.svg';

const Page404 = () => {
	return (
		<main className={ `error__main` }>
			<div className={ `error__container` }>
				<img
					src={ btu_logo }
					alt={ 'logo btu' }
					className={ `error__logo` }
				/>
				<p><strong>404.</strong> Error.</p>
				<p>Podany adres nie istnieje lub jest błędnie podany.</p>
			</div>
		</main>
	);
};
export default Page404;